import { render } from "./HomePageSix.vue?vue&type=template&id=d408ea36"
import script from "./HomePageSix.vue?vue&type=script&lang=js"
export * from "./HomePageSix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__